export const AuthURL = {
    LOGIN: '/login',
    REGISTRATION: '/registration',
    LOGOUT: '/logout',

    FORGOT_PASSWORD: '/forgot-password',
    SET_NEW_PASSWORD : '/reset-password/:uid/:token',
};
